import React, {useState, useEffect} from 'react';
import Pagination from 'react-js-pagination';
import {useSelector} from 'react-redux';
import {NavLink, useHistory, useLocation} from 'react-router-dom';
import Table from 'react-bootstrap/Table';
import {toast} from 'react-toastify';
import {useMutation, useQuery, useInfiniteQuery} from 'react-query';
import {Image} from 'react-bootstrap';
import {AsyncPaginate} from 'react-select-async-paginate';
import {
    EXERCISE_API,
    BaseGatewayImage,
    DISEASE_API,
    PATIENTEXERCISE_API
} from '@app/utils/apiUrl.js';
import {DeleteSingle, Get} from '@app/utils/httpProvider';
import {
    createUrlWithParam,
    formatDateTimeCrawler,
    formatDateTimeMoment,
    formatDateTimeWithoutHour,
    formatDateTimeWithoutHourMoment,
    getInfomationAccountFromToken,
    isValidUrl
} from '../../utils/helper';
import {URI_INTERNAL} from '../../utils/pathLocations';
import {
    objectShowNumber,
    messageToast,
    objectDeviceStatus,
    deviceStatus,
    styleSelectDefault,
    role,
    objectTrangThaiDeNghi,
    trangThaiDeNghiValue,
    sortByValue
} from '../../utils/define';
import {ConfirmModal} from '../../modules/modal/ConfirmModal';
import {BrowserView, MobileView} from 'react-device-detect';
import Select from 'react-select';
import {Button} from '@components';

const PatientExercise = () => {
    const history = useHistory();
    const location = useLocation();
    const valueSearch = useSelector((state) => state.search.valueSearch);

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(4);
    const [search, setSearch] = useState('');

    const [openConfirmDeleteModal, setOpenConfirmDeleteModal] = useState(false);
    const [idWantDelete, setIdWantDelete] = useState('');
    const [confirmDelMessage, setConfirmDelMessage] = useState('');
    const [diseaseId, setDiseaseId] = useState('');
    const [diseaseName, setDiseaseName] = useState('');

    // let accountRoleAdmin = false;
    const inforAccount = getInfomationAccountFromToken();

    // if (inforAccount && inforAccount.role) {
    //     const userRole = inforAccount.role.split(', ');
    //     accountRoleAdmin =
    //         userRole.includes(role.Admin) || userRole.includes(role.Doctor);
    // }

    const deleteFunc = useMutation((value) =>
        DeleteSingle(EXERCISE_API.DELETE_ITEM, value, null)
    );

    const paramUrl = new URLSearchParams(location.search.substring(1));
    if (
        paramUrl.get('page') != null &&
        parseInt(paramUrl.get('page'), 10) !== page
    ) {
        const pageResult = parseInt(paramUrl.get('page'), 10);
        setPage(pageResult);
    }
    if (
        paramUrl.get('size') != null &&
        parseInt(paramUrl.get('size'), 10) !== pageSize
    ) {
        const sizeResult = parseInt(paramUrl.get('size'), 10);
        setPageSize(sizeResult);
    }
    if (paramUrl.get('search') != null && paramUrl.get('search') !== search) {
        setSearch(paramUrl.get('search'));
    }

    // const [isSortedNameAlphabet, setIsSortedNameAlphabet] = useState(false);

    const {
        data,
        fetchNextPage,
        hasNextPage,
        isFetchingNextPage,
        status,
        error
    } = useInfiniteQuery(
        ['selectPatientExerciseData', valueSearch, inforAccount.id],
        ({pageParam = 1}) => {
            let model = {
                Keyword: valueSearch ? valueSearch : '',
                PageIndex: pageParam,
                PageSize: pageSize,
                IsDescCreatedDate: true,
                AccountPatientId: inforAccount.id
            };

            return Get(PATIENTEXERCISE_API.GET_PAGING_WITH_PATIENT, null, model);
        },
        {
            // nếu trả về đúng pageSize thì có trang kế tiếp
            getNextPageParam: (lastPage) =>
                lastPage.data.length === pageSize
                    ? lastPage.pageIndex + 1
                    : undefined
        }
    );

    const patientExercises = data?.pages.flatMap((page) => page.data) ?? [];

    if (status === 'loading') {
        return <p>Đang tải dữ liệu…</p>;
    }
    if (status === 'error') {
        return <p>Có lỗi: {error.message}</p>;
    }

    // useEffect(() => {
    //     refetch();
    // }, [pageSize, page, diseaseId]);

    // const replaceHistory = async (Page, Size, Search) => {
    //     history.replace(
    //         createUrlWithParam(URI_INTERNAL.PATIENTEXERCISE_CHOSEN_PATH, {
    //             page: Page,
    //             size: Size,
    //             search: Search
    //         })
    //     );
    // };

    // React.useEffect(() => {
    //     if (valueSearch != null && valueSearch !== search) {
    //         // replaceHistory(1, pageSize, valueSearch);
    //     }
    // }, [valueSearch]);

    // const changePage = (number) => {
    //     setPage(number);
    //     replaceHistory(number, pageSize, search);
    // };

    // const onChangeShowNumber = (e) => {
    //     setPageSize(e.target.value);
    //     replaceHistory(page, e.target.value, search);
    // };

    // const deleteAction = (id, name) => {
    //     setIdWantDelete(id);
    //     setConfirmDelMessage(name);
    //     setOpenConfirmDeleteModal(true);
    // };

    // const acceptDelete = async () => {
    //     if (idWantDelete !== '') {
    //         deleteFunc.mutate(idWantDelete, {
    //             onSuccess: (res) => {
    //                 if (res.status === 201 || res.status === 200) {
    //                     refetch();
    //                     toast.success(messageToast.messageToastDeleteSuccess);
    //                     if (
    //                         data != null &&
    //                         data.data.length === 1 &&
    //                         page !== 1
    //                     ) {
    //                         history.push(
    //                             createUrlWithParam(URI_INTERNAL.EXERCISE_PATH, {
    //                                 page: page - 1,
    //                                 size: pageSize,
    //                                 search: search
    //                             })
    //                         );
    //                     }
    //                 } else {
    //                     toast.error(messageToast.messageToastDeleteError);
    //                 }
    //             },
    //             onError: (res) => {
    //                 toast.error(messageToast.messageToastTryCatch);
    //             }
    //         });

    //         replaceHistory(page, pageSize, search);
    //         setOpenConfirmDeleteModal(false);
    //     }
    // };

    // const cancelDelete = () => {
    //     setIdWantDelete('');
    //     setOpenConfirmDeleteModal(false);
    // };

    // const loadOptions = async (search, loadedOptions, {page}) => {
    //     const pageSize = 10;
    //     const res = await Get(DISEASE_API.GET_PAGING, null, {
    //         PageIndex: page,
    //         PageSize: pageSize,
    //         AccountPatientId: inforAccount.id,
    //         Keyword: search // pass the input text to filter server-side
    //     });

    //     const data = res.data || [];
    //     const options = data.map((x) => ({
    //         label: `${x.name}`,
    //         value: x.id
    //     }));

    //     // assume your API returns total count or a flag for more pages
    //     const hasMore = data.length === pageSize;
    //     return {
    //         options,
    //         hasMore,
    //         additional: {page: page + 1}
    //     };
    // };

    return (
        // <div className="container-fluid">
        //     <div id="disease-tab-content" className="tab-content active">
        //         <div className="row">
        //             <div className="col-md-12">
        //                 <div id="exercises-list">
        //                     <div className="row">
        //                         {data != null &&
        //                         data.data != null &&
        //                         data.data != null &&
        //                         data.data !== undefined &&
        //                         data.data.length > 0 ? (
        //                             <>
        //                                 {data.data.map((item, index) => (
        //                                     <div className="col-md-6">
        //                                         <div className="card exercise-item">
        //                                             <div className="card-header">
        //                                                 <h3 className="card-title"></h3>
        //                                             </div>
        //                                             <div className="card-body">
        //                                                 <p>{item.exercise.name}</p>
        //                                                 <p>{item.accountDoctor.fullName}</p>
        //                                                 <p>Tập trong: {item.numberOfDay}</p>
        //                                                 <p>Từ ngày: {formatDateTimeWithoutHourMoment(item.fromDate)}</p>
        //                                                 <p>Đến ngày: {formatDateTimeWithoutHourMoment(item.toDate)}</p>
        //                                                 <Button
        //                                                     as={NavLink}
        //                                                     to={createUrlWithParam(
        //                                                         URI_INTERNAL.PATIENTPRACTICE_PATH,
        //                                                         {chonbaiId: item.id}
        //                                                     )}
        //                                                     className="btn btn-primary select-exercise"
        //                                                     activeClassName="active" // adds .active when route matches
        //                                                 >
        //                                                     <i className="fas fa-check-circle" />{' '}
        //                                                     Chọn bài tập
        //                                                 </Button>
        //                                             </div>
        //                                         </div>
        //                                     </div>
        //                                 ))}
        //                             </>
        //                         ) : (
        //                             <></>
        //                         )}
        //                     </div>
        //                 </div>
        //             </div>
        //         </div>
        //     </div>
        // </div>
        // <div className="container-fluid">
        //     <div id="disease-tab-content" className="tab-content active">
        //         <div className="row">
        //             <div className="col-md-12">
        //                 <div id="exercises-list">
        //                     <div className="row row-cols-1 row-cols-md-2 g-4">
        //                         {data?.data?.length > 0 ? (
        //                             data.data.map((item) => (
        //                                 <div className="col" key={item.id}>
        //                                     <div className="card h-100 shadow-sm">
        //                                         <div className="card-header bg-primary text-white">
        //                                             <h5 className="card-title mb-0">
        //                                                 {item.exercise.name}
        //                                             </h5>
        //                                         </div>
        //                                         <div className="card-body">
        //                                             <p className="mb-2">
        //                                                 <strong>Bác sĩ:</strong>{' '}
        //                                                 {
        //                                                     item.accountDoctor
        //                                                         .fullName
        //                                                 }
        //                                             </p>
        //                                             <p className="mb-2">
        //                                                 <strong>
        //                                                     Số ngày:
        //                                                 </strong>{' '}
        //                                                 {item.numberOfDay}
        //                                             </p>
        //                                             <p className="mb-2">
        //                                                 <strong>Từ:</strong>{' '}
        //                                                 {formatDateTimeWithoutHourMoment(
        //                                                     item.fromDate
        //                                                 )}
        //                                             </p>
        //                                             <p className="mb-2">
        //                                                 <strong>Đến:</strong>{' '}
        //                                                 {formatDateTimeWithoutHourMoment(
        //                                                     item.toDate
        //                                                 )}
        //                                             </p>
        //                                         </div>
        //                                         <div className="card-footer bg-light text-end">
        //                                             <Button
        //                                                 as={NavLink}
        //                                                 to={createUrlWithParam(
        //                                                     URI_INTERNAL.PATIENTPRACTICE_PATH,
        //                                                     {chonbaiId: item.id}
        //                                                 )}
        //                                                 className="btn btn-success"
        //                                             >
        //                                                 <i className="fas fa-check-circle me-1" />
        //                                                 Chọn bài tập
        //                                             </Button>
        //                                         </div>
        //                                     </div>
        //                                 </div>
        //                             ))
        //                         ) : (
        //                             <div className="col-12">
        //                                 <p className="text-center text-muted">
        //                                     Chưa có bài tập nào để hiển thị
        //                                 </p>
        //                             </div>
        //                         )}
        //                     </div>
        //                 </div>
        //             </div>
        //         </div>
        //     </div>
        // </div>
        <div className="container-fluid">
            <div className="row row-cols-1 row-cols-md-2 g-4">
                {patientExercises.map((item) => (
                    <div className="col-md-4" key={item.id}>
                        <div className="card h-100 shadow-sm">
                            <div className="card-header bg-primary text-white">
                                <h5 className="card-title mb-0">
                                    {item.exercise.name}
                                </h5>
                            </div>
                            <div className="card-body">
                                <p>
                                    <strong>Bác sĩ:</strong>{' '}
                                    {item.accountDoctor.fullName}
                                </p>
                                <p>
                                    <strong>Số ngày:</strong> {item.numberOfDay}
                                </p>
                                <p>
                                    <strong>Từ:</strong>{' '}
                                    {formatDateTimeWithoutHourMoment(
                                        item.fromDate
                                    )}
                                </p>
                                <p>
                                    <strong>Đến:</strong>{' '}
                                    {formatDateTimeWithoutHourMoment(
                                        item.toDate
                                    )}
                                </p>
                            </div>
                            <div className="card-footer bg-light text-end">
                                <Button
                                    as={NavLink}
                                    to={createUrlWithParam(
                                        URI_INTERNAL.PATIENTPRACTICE_PATH,
                                        {chonbaiId: item.id}
                                    )}
                                    className="btn btn-success"
                                >
                                    <i className="fas fa-check-circle me-1" />{' '}
                                    Chọn bài tập
                                </Button>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {hasNextPage && (
                <div className="text-center mt-4">
                    <button
                        className="btn btn-primary"
                        onClick={() => fetchNextPage()}
                        disabled={isFetchingNextPage}
                    >
                        {isFetchingNextPage ? 'Đang tải…' : 'Lấy thêm bài tập'}
                    </button>
                </div>
            )}

            {!hasNextPage && patientExercises.length > 0 && (
                <p className="text-center text-muted mt-3">Đã hết dữ liệu</p>
            )}

            {patientExercises.length === 0 && (
                <p className="text-center text-muted mt-3">
                    Chưa có bài tập nào để hiển thị
                </p>
            )}
        </div>
    );
};

export default PatientExercise;
